'use client';

import Swal from "sweetalert2";
import { useRouter } from "next/navigation";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { getSocket } from '@/app/global-functions/getSocket';
import { getBaseURL } from "./baseURLUtils-administrators";
import { handleRedirection } from "./handleRedirection";
import { useSelector } from "../store";
import { getUniversityName } from "./getUniversityName";
import { getUserEmailUpdateData } from "../services/admin/UserLogin.services";
import { setParamMemoire } from "../store/slices/diversParametersRedux";
import UserService from "../services/admin/User.service";
import { logouAllSystem } from "./logout/logouAllSystem";

const ShowSessionExpiredAlert = ({ abreviaturaUniversidade, onConfirm }) => {
  const intl = useIntl();
  const navigate = useRouter();
  const url = getBaseURL(); // backend URL
  const { paramMemoire } = useSelector((state) => state.diversParametersRedux);
  const [abreviaturaUniversidade1, setAbreviaturaUniversidade] = useState("");
  const [userEmail, setuserEmail] = useState("");

  const [userID, setuserID] = useState("");

  const [typeUtilisateur, settypeUtilisateur] = useState("");

  const [userIDStudent, setuserIDStudent] = useState("");
  
  useEffect(() => {

    fetchUniversityName();
    getdadosLoginFalse();

   const socket = getSocket(url);

    // Check if socket is available and emit the disconnect event
      paramMemoire.forEach((item) => {
         const userID2 = item.id;
         setuserEmail(item.emaiUtulisateur)
         setuserID(item.id);
         settypeUtilisateur(item.typeUtilisateur);
         setuserIDStudent(item.userID);
      //   console.log("Emitting disconnectUser event for userID:", userID);

        // Emit disconnect event
        if (Number(userID2) > 0) {
         //  console.log("Emitting disconnectUser event for userID:", userID);
          socket.emit("disconnectUser", { socketId: socket.id, userID2 });
        }
      });

      socket.on("disconnect", (reason) => {
        //   console.log("Disconnected from WebSocket:", reason);
      });

      socket.off("connect");
      socket.off("disconnect");

      // Ensure the socket is properly disconnected
     //  socket.disconnect();
      // console.log("Socket disconnected after emitting event.");
    

    // Open session expired popup
    openPopup();

    return () => {
      //  console.log("Cleaning up WebSocket...");
       socket.off("connect");
       socket.off("disconnect");
     };
     
  }, [paramMemoire, url, abreviaturaUniversidade, userEmail], userID, typeUtilisateur);

  const fetchUniversityName = async () => {
    const university = await getUniversityName();
    setAbreviaturaUniversidade(university.abreviatura);

  };


  const getdadosLoginFalse = async () => {
    const response = await getUserEmailUpdateData(userEmail);
    const testData = response.data;

    setParamMemoire([
      {
        ...testData.user, // Spreading all existing properties of the user object
        isLoggedIn2: false, // Adding or overriding the `isLoggedIn2` property
      },
    ]) 
  }

  const openPopup = async () => {

    try {
      
  
      const socket = getSocket(url);
  
      socket.on("connect", () => {
        console.log("Connected to WebSocket:", socket.id);
        socket.emit("userOnline", { userID });
      });
  
      socket.on("disconnect", (reason) => {
        console.log("Disconnected from WebSocket:", reason);
      });
  
      const university = await getUniversityName();
      setAbreviaturaUniversidade(university.abreviatura);
  
      if (Number(typeUtilisateur) < 3) {

        const disconnect2 = {
          enligne: 0,
          disconectBeforeConnect: 0,
          tipo: "updateEnLigneNew",
          userID,
        };
  
        await UserService.update(userID, disconnect2).then(async (response) => {
          await handleRedirection(university.abreviatura, navigate);
  
         await  logouAllSystem();

          if (onConfirm) {
            await handleRedirection(university.abreviatura, navigate);
            await  onConfirm();
         //   await  logouAllSystem();
          }
        });


      }
  
      if (Number(typeUtilisateur) === 3) {
        const disconnect2 = {
          enligne: 0,
          disconectBeforeConnect: 0,
          tipo: "updateEnLigneNew",
          userID,
        };
  
        await UserService.updateStudent(userIDStudent, disconnect2).then(
          async (response) => {
            await handleRedirection(university.abreviatura, navigate);
  

          logouAllSystem();
            if (onConfirm) {
              const university = await getUniversityName();          
              await handleRedirection(university.abreviatura, navigate);
              onConfirm();

        //   logouAllSystem();
            }
          }
        );
      }
    } catch (error) {
      
    }
    
  
    Swal.fire({
      title: intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
      text: intl.formatMessage({ id: "session_expire" }),
      icon: "warning",
      confirmButtonText: "OK",
      allowOutsideClick: false, // Prevent clicking outside
      allowEscapeKey: false,    // Prevent using Escape key
      didOpen: () => {
        // Disable navigation by focusing on the modal
        Swal.getConfirmButton().focus();
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        const university = await getUniversityName();     
        await handleRedirection(university.abreviatura, navigate);

      }
    });

  };

  return null; // This component only handles logic and does not render any UI

  
};

export default ShowSessionExpiredAlert;